import { render } from "./MyPreloader.vue?vue&type=template&id=98a66400&scoped=true"
import script from "./MyPreloader.vue?vue&type=script&lang=js"
export * from "./MyPreloader.vue?vue&type=script&lang=js"

import "./MyPreloader.vue?vue&type=style&index=0&id=98a66400&scoped=true&lang=css"

import exportComponent from "/home/user/dev/teacher-soft/datepickerDev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98a66400"]])

export default __exports__